import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApiAuth } from 'modules/api';
import { UserCredentials } from 'modules/types/UserCredentials';
import { TfaTypes } from '../../../../types/User';

export const fetchUser = createAsyncThunk(
  'auth/getUser',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiAuth.getUser();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const login = createAsyncThunk(
  'auth/login',
  async (userCredentials: UserCredentials, { rejectWithValue }) => {
    try {
      const response = await ApiAuth.login(userCredentials);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const tfaVerifyCode = createAsyncThunk(
  'auth/tfaVerifyCode',
  async (userCredentials: UserCredentials, { rejectWithValue }) => {
    try {
      await ApiAuth.tfaVerifyCode(userCredentials);
      const response = await ApiAuth.getUser();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const chooseTfaProvider = createAsyncThunk(
  'auth/tfaProviderChoice',
  async (providerDto: TfaTypes, { rejectWithValue }) => {
    try {
      const response = await ApiAuth.tfaProviderChoice(providerDto);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const mailCodeResend = createAsyncThunk(
  'auth/mailCodeResend',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiAuth.mailCodeResend();
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const qrCodeReset = createAsyncThunk(
  'auth/qrCodeReset',
  async (token: string, { rejectWithValue }) => {
    try {
      const response = await ApiAuth.qrCodeReset(token);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const qrCodeResetRequest = createAsyncThunk(
  'auth/qrCodeResetRequest',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiAuth.qrCodeResetRequest();
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const resetTfaProvider = createAsyncThunk(
  'auth/resetTfaProvider',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiAuth.resetTfaProvider();
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const resetTfaProviderApproved = createAsyncThunk(
  'auth/resetTfaProviderApproved',
  async (token: string, { rejectWithValue }) => {
    try {
      const response = await ApiAuth.resetTfaProviderApproved(token);
      return response.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const logout = createAsyncThunk(
  'auth/logout',
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiAuth.logout();
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const forgottenPassword = createAsyncThunk(
  'auth/forgotten-password',
  async (username: string, { rejectWithValue }) => {
    try {
      const response = await ApiAuth.forgottenPassword(username);
      return response;
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
